<template>
  <div v-if="localShow" class="modal-overlay" @click="closeModal">
    <div class="modal-dialog" @click.stop>
      <BaseDialog
        :title="'Create New Annotation Set'"
        :footerButtons="['Create New Set']"
        @cancel="closeModal"
        @footer-click="handleFooterClick"
      >
        <div class="settings__control-group">
          <label>Name</label>
          <input
            ref="annSetName"
            v-model="name"
            class="select"
            type="text"
          >
        </div>
        <div class="settings__control-group">
          <label>Description</label>
          <textarea
            v-model="description"
            rows="4"
            cols="50"
          />
        </div>
      </BaseDialog>
    </div>
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import BaseDialog from '@/components/DilaogTemplate/BaseDialog.vue';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

const $toast = useToast();

export default {
  name: 'CreateAnnotationSetModal',
  components: {
    BaseDialog,
  },
  props: {
    datasetId: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  emits: ['annotation-set-created', 'annotation-set-created-error', 'closed'],
  data() {
    return {
      name: 'annotations',
      description: '',
      localShow: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
  created() {
    this.dataConnect = new DatastoreConnect(this.$store.state.enterpriseServerUrl);
  },
  methods: {
    showModal() {
      this.localShow = true;
      this.$nextTick(() => {
        this.$refs.annSetName.focus();
      });
    },
    closeModal() {
      this.name = 'annotations';
      this.description = '';
      this.$emit('closed');
      this.localShow = false;
    },
    handleFooterClick(buttonLabel) {
      if (String(buttonLabel || '').toLowerCase() === 'create new set') {
        this.createAnnotationSet();
      }
    },
    async createAnnotationSet() {
      if (!this.name) {
        $toast.open({
          queue: true,
          message: `Failed to create annotation set: Missing name`,
          type: 'error',
          position: 'top',
          dismissible: true,
        });
        return;
      }
      const resp = await this.dataConnect.createAnnotationSet({
        name: this.name,
        description: this.description,
        operator: this.user.username,
        origin_x: 0,
        origin_y: 0,
        dataset_id: this.datasetId,
      })
        .catch((error) => {
          $toast.open({
            queue: true,
            message: `Failed to create annotation set: ${error}`,
            type: 'error',
            position: 'top',
            dismissible: true,
          });
        });
      if (resp.error || !resp.result) {
        $toast.open({
          queue: true,
          message: `Failed to create annotation set: ${resp.error.message}`,
          type: 'error',
          position: 'top',
          dismissible: true,
        });
        this.$emit('annotation-set-created-error', resp.error);
      } else {
        this.name = '';
        this.description = '';
        this.closeModal();
        this.$emit('annotation-set-created', resp.result);
      }
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/css/themes/auzone/buttons.scss';

.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
}

.modal-dialog {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

